module.exports = __webpack_public_path__ + "img/banner0.2773eb8c.png";